import React from "react";

import { useTransition, animated } from "react-spring";
import classnames from "classnames";

import { Dialog } from "@headlessui/react";

export interface CustomContentModalProps {
  isOpen: boolean;
  className?: string;
  onClose: any;
  children?: React.ReactNode;
}

export const CustomContentModal: React.FC<CustomContentModalProps> = (
  props
) => {
  const config = {
    mass: 1,
    tension: 160,
    friction: 20,
    clamp: true,
  };

  const dialog = useTransition(props.isOpen, {
    from: { opacity: 0 },
    enter: { opacity: 1 },
    leave: { opacity: 0 },
    config,
  });

  const content = useTransition(props.isOpen, {
    from: { opacity: 0, transform: "scale(0.95)" },
    enter: { opacity: 1, transform: "scale(1.00)" },
    leave: { opacity: 0, transform: "scale(0.95)" },
    config,
  });

  return dialog(
    (styles, item) =>
      item && (
        <Dialog
          static
          open={props.isOpen}
          onClose={props.onClose}
          as={animated.div}
          className="relative z-50"
          style={styles}
        >
          <div className="fixed inset-0 bg-black bg-opacity-50 dark:bg-opacity-70" aria-hidden="true" />
          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4">
              {content(
                (contentStyles, contentItem) =>
                  contentItem && (
                    <animated.div
                      className={classnames(
                        'relative flex w-full justify-center py-8 transform',
                        props.className
                      )}
                      style={contentStyles}
                    >
                      {props.children}
                    </animated.div>
                  )
              )}
            </div>
          </div>
        </Dialog>
      )
  )
};
